import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController, NavParams } from '@ionic/angular';
import { getIcon, isDesktop } from '../../../helpers';
import { fbInstaConsent } from './fb-insta-consent';
import { twitterConsent } from './twitter-consent';
import { youtubeConsent } from './youtube-consent';
import { linkedInConsent } from './linkedin-consent';
import { defaultConsent } from './default-consent';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import {
  Platform,
  platformName,
} from '@jaimo-solutions-gmbh/platform-services-module/lib/platforms';
import { tiktokConsent } from './tiktok-consent';
import { getPlatformByUrl } from 'src/app/utils/blacklist';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrls: ['./consent.component.scss'],
})
export class ConsentComponent implements OnInit {
  @ViewChild('consentContent') consentContent: ElementRef;
  url: string;
  platform: Platform;
  content;

  redirectTo;
  globeIcon = faTriangleExclamation;

  constructor(
    private modalCtrl: ModalController,
    navParams: NavParams,
    private sanitizer: DomSanitizer
  ) {
    this.url = navParams.get('url');
    this.platform = navParams.get('platform');
    this.content = this.sanitizer.bypassSecurityTrustHtml(
      this.getContent(this.platform)
    );
    this.redirectTo =
      platformName[getPlatformByUrl(this.url)] ?? 'eine externe Seite';
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.registerEvents();
  }

  registerEvents() {
    const anchors = this.consentContent.nativeElement.querySelectorAll('a');
    anchors.forEach((anchor: HTMLAnchorElement) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        const href = anchor.getAttribute('href');
        const element = document.getElementById(href.slice(1, href.length));
        element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  getIcon = (platform?: Platform) =>
    !platform ? this.globeIcon : getIcon(platform);

  getContent(platform: Platform) {
    const platformConsent: Record<string, string> = {
      'x-twitter': twitterConsent,
      youtube: youtubeConsent,
      facebook: fbInstaConsent,
      instagram: fbInstaConsent,
      linkedin: linkedInConsent,
      tiktok: tiktokConsent,
      default: defaultConsent,
    };

    return platformConsent[platform] ?? defaultConsent;
  }

  isDesktop = () => isDesktop();

  back() {
    this.modalCtrl.dismiss();
  }

  redirect() {
    window.open(this.url, '_blank');
    this.modalCtrl.dismiss();
  }
}
